module.exports = __webpack_public_path__ + "static/media/bastadvapen.0ccb0f53.png";